import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BrandDivider from '../BrandDivider';

const NavCard = ({ link, cardImage, image, header, title, description }) => {
  if (!link?.link) return null;
  const linkObj = buildLinkObj(link);
  const imgUrl = buildImageSrc(image || cardImage, 800, 2, 1);

  return (
    <Box
      flex={1}
      mx={{ xs: 0, md: 2 }}
      mb={{ xs: 2, md: 0 }}
      sx={{ textAlign: 'center', bgcolor: 'white' }}
    >
      <Box
        component="a"
        rel={getRel(linkObj)}
        href={linkObj.href}
        display="flex"
        flexDirection="column"
        sx={{ height: '100%' }}
      >
        <LazyLoadImage imgComponent={<img src={imgUrl} alt="" className="tw-max-w-full" />} />
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          p={2}
          sx={{ border: (theme) => `1px solid ${theme.palette.warm[100]}` }}
        >
          {header && (
            <Typography variant="subtitle1" mb={1}>
              {header}
            </Typography>
          )}
          {title && (
            <Typography component="h2" variant="h5">
              {title}
            </Typography>
          )}
          {description && (
            <>
              <BrandDivider />
              <Typography
                variant="body2"
                mt={2}
                sx={{ flex: 1, '&:hover': { color: (theme) => theme.palette.neutral[800] } }}
              >
                {description}
              </Typography>
            </>
          )}
          <Typography component="span" variant="body2" mt={3} sx={{ textDecoration: 'underline' }}>
            {link.displayName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NavCard;
